let Vue = require('vue');
let displayBuildingCompositionTemplate = require('templates/buildings/building-composition.html');

Vue.component('display-info', {
    twoWay: true,
    template: displayBuildingCompositionTemplate,
    props: {
        model: {
            twoWay: true,
            type: Array
        },
        label: {
            twoWay:false,
            type: String,
            default: ''
        }
    }, data() {
        return {
            result: {}
        }
    },ready(){
        this.transformModel();
    }, methods: {
        transformModel()
        {
            let first = this.model[0];
            let last = this.model[this.model.length -1];

            if (first == last) {
                return this.result = first;
            }
            this.result = first + ' a ' + last
            return this.result;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/display-building-composition.js